export default "__VITE_ASSET__bcacfa30__"